import styled from "styled-components";

import { EarthHomeWorld } from "@ui/Assets/MyIcons/EarthHomeWorld";
import { text } from "@ui/helpers";

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: ${({ theme }) => theme.spacing.spacing_4};
  color: ${({ theme }) => theme.palette.white};
`;

export const Select = styled.select`
  ${text("medium_18")}
  color: ${({ theme }) => theme.palette.white};
  background: transparent;
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.blue50};
  }
`;

export const Option = styled.option`
  color: ${({ theme }) => theme.palette.black};
`;

export const EarthHomeWorldIcon = styled(EarthHomeWorld).attrs(props => ({
  width: props.theme.icons.sizes.base_x3,
}))`
  display: none;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    display: block;
  }
`;
